export function popup() {

	var popupContainer = document.querySelectorAll(".apoFinder_Stoerer, .apo-overlay");
	if (!popupContainer.length) return;

	var closeButton = document.querySelectorAll(".btn-popup-close");

	closeButton.forEach(function (item) {
		item.addEventListener('click', function (event) {
			popupContainer.forEach(function (item) {
				item.classList.remove("show");
			});
		});
	});
};
